import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Spin, message } from 'antd';
import ViewModal from '../../components/VacancyRequests/ViewModal';
import {
    fetchVacancyRequestById,
    fetchVacancyRequestHistory,
    fetchApprovalRoute,
    fetchVacanciesByVacancyRequest,
    updateVacancyRequest
} from '../../redux/vacancyRequestsSlice';
import { fetchUsers } from '../../redux/userOrganisationsSlice';
import { fetchVacancies } from '../../redux/vacanciesSlice';

const VacancyRequestDetailsPage = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { current: request, history, approvalRoute, vacancies: requestVacancies, isLoading } = useSelector((s) => s.vacancyRequests);
    const { list: users } = useSelector((s) => s.userOrganisations);
    const { list: vacancies } = useSelector((s) => s.vacancies);
    const { organisations } = useSelector((s) => s.organisationDepartment);
    const { orgId, user } = useSelector((s) => s.auth);

    useEffect(() => {
        if (!id) return;
        const load = async () => {
            try {
                const requestId = parseInt(id);
                await Promise.all([
                    dispatch(fetchVacancyRequestById({ id: requestId, organisationId: orgId })).unwrap(),
                    users?.length ? Promise.resolve() : dispatch(fetchUsers({ skip: 0, limit: 20 })).unwrap(),
                    vacancies?.length ? Promise.resolve() : dispatch(fetchVacancies({ skip: 0, limit: 20, org_id: 'all' })).unwrap(),
                    // organisations уже загружены в Layout из auth.userOrganisations
                    dispatch(fetchVacancyRequestHistory({ id: requestId, organisationId: orgId })).unwrap(),
                    dispatch(fetchApprovalRoute(requestId)).unwrap(),
                    dispatch(fetchVacanciesByVacancyRequest({ id: requestId })).unwrap(),
                ]);
            } catch (e) {
                message.error('Не удалось загрузить заявку');
            }
        };
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, orgId]);

    const handleClose = useCallback(() => {
        navigate('/vacancy-requests');
    }, [navigate]);

    const handleCommentSubmit = useCallback(async (requestId, comment) => {
        try {
            await dispatch(updateVacancyRequest({ id: requestId, organisationId: orgId, vacancyRequest: { comment } })).unwrap();
            await dispatch(fetchVacancyRequestHistory({ id: requestId, organisationId: orgId })).unwrap();
        } catch (e) {
            message.error('Ошибка при сохранении комментария');
        }
    }, [dispatch, orgId]);

    if (isLoading && !request) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!request) return null;

    return (
        <div style={{ padding: 24 }}>
            <ViewModal
                visible={true}
                onCancel={handleClose}
                onCommentSubmit={handleCommentSubmit}
                request={request}
                vacancies={vacancies}
                organisations={organisations}
                users={users}
                currentUserId={user?.id}
            />
        </div>
    );
};

export default VacancyRequestDetailsPage;


